const CAROUSEL_ITEMS = [
  {
    title: '娱乐圈年度大瓜盘点：那些轰动全网的爆料瞬间',
    desc: '回顾过去一年最具冲击力的娱乐爆料事件，从顶流塌房到隐秘恋情，每一件都曾引爆热搜。',
    tag: '年度专题',
  },
  {
    title: '科技圈黑幕深度调查：从芯片到算法的隐秘战争',
    desc: '多位业内人士联合爆料，揭开科技巨头之间不为人知的商业竞争内幕与行业潜规则。',
    tag: '深度调查',
  },
  {
    title: '食品安全红黑榜：你每天都在吃的那些东西安全吗',
    desc: '汇总近期食品安全领域爆料精华，从外卖到零食，帮你避开那些看不见的消费陷阱。',
    tag: '消费警示',
  },
  {
    title: '职场生存指南：那些HR不会告诉你的公司潜规则',
    desc: '从招聘黑话到离职博弈，职场人匿名分享的真实经历，帮你少走弯路。',
    tag: '职场揭秘',
  },
  {
    title: '直播带货乱象实录：从选品到售后全链路大起底',
    desc: '跟随内部人士的镜头，走进直播带货行业的灰色地带，揭开流量与销量的真实面纱。',
    tag: '行业揭秘',
  },
  {
    title: '房产变局：2026下半年楼市政策风向与购房者生存实录',
    desc: '多地楼市新政密集出台，业主与准业主的真实声音，还原一个真实的房地产市场。',
    tag: '楼市观察',
  },
];

export default function CarouselSection() {
  const getImageSrc = (index: number) => {
    const images = [
      'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20illustration%20of%20entertainment%20industry%20breaking%20news%20with%20spotlight%20and%20stage%20elements%2C%20warm%20orange%20and%20coral%20tones%2C%20magazine%20cover%20style%2C%20dramatic%20composition%2C%20bold%20graphic%20design&width=800&height=500&seq=carousel-focus-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=A%20futuristic%20editorial%20illustration%20of%20technology%20industry%20secrets%20with%20circuit%20board%20and%20digital%20elements%2C%20warm%20amber%20and%20dark%20tones%2C%20investigative%20journalism%20style%2C%20dramatic%20lighting%2C%20tech%20noir%20aesthetic&width=800&height=500&seq=carousel-focus-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20about%20food%20safety%20and%20consumer%20awareness%20with%20warm%20orange%20and%20cream%20tones%2C%20minimalist%20flat%20design%2C%20food%20items%20with%20warning%20signs%2C%20clean%20composition%2C%20informational%20design%20style&width=800&height=500&seq=carousel-focus-03&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20workplace%20culture%20and%20office%20politics%20with%20warm%20coral%20and%20beige%20tones%2C%20modern%20office%20elements%20in%20abstract%20style%2C%20flat%20design%2C%20professional%20yet%20approachable%20aesthetic&width=800&height=500&seq=carousel-focus-04&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20live%20streaming%20ecommerce%20industry%20with%20warm%20orange%20and%20gold%20tones%2C%20shopping%20cart%20and%20camera%20elements%2C%20modern%20graphic%20design%2C%20vibrant%20energy%2C%20reporting%20style%20aesthetic&width=800&height=500&seq=carousel-focus-05&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20real%20estate%20market%20trends%20with%20warm%20amber%20and%20terracotta%20tones%2C%20building%20silhouettes%20and%20graph%20elements%2C%20minimalist%20design%2C%20real%20estate%20theme%2C%20informational%20graphic%20style&width=800&height=500&seq=carousel-focus-06&orientation=landscape',
    ];
    return images[index];
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度策划的爆料专题，带你透视事件全貌
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={getImageSrc(i)}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-[11px] font-semibold backdrop-blur-sm whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <div className="mt-4 flex items-center text-sm text-primary-500 font-medium">
                  阅读全文 <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}